/* Generated from Odingard/guardian docs/generated/public-catalog.v1.json @ b2c49ac (pnpm catalog:generate). Do not edit by hand. */
/* eslint-disable */
export default {
 "source": "Odingard/guardian docs/generated/public-catalog.v1.json @ b2c49ac",
 "counts": {
  "verticals": 62,
  "agentSystems": 25,
  "agentRoles": 48,
  "entities": 221
 },
 "verticals": [
  {
   "id": "vpk_ai-infrastructure.agent-gateways",
   "sector": "ai-infrastructure",
   "title": "Agent Gateways",
   "description": "Agent-facing gateways \u2014 API requests, tool invocation, credential use and protected-data use through enforced surfaces.",
   "tier": "governed",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Bounded API request",
    "Invoke a tool",
    "Bounded local execution",
    "Use a stored credential",
    "Use protected data"
   ]
  },
  {
   "id": "vpk_ai-infrastructure.agent-platforms",
   "sector": "ai-infrastructure",
   "title": "Agent Platforms",
   "description": "Foundation-model agent platforms \u2014 agents that plan, spawn, delegate, invoke tools and change models or runtimes.",
   "tier": "governed",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Invoke a tool",
    "Spawn a sub-agent",
    "Delegate a task",
    "Terminate an agent",
    "Configure an agent",
    "Write agent memory",
    "Change runtime",
    "Change model",
    "Agent-to-agent message",
    "Transfer a task",
    "Transfer a capability"
   ]
  },
  {
   "id": "vpk_ai-infrastructure.mcp-ecosystems",
   "sector": "ai-infrastructure",
   "title": "MCP Ecosystems",
   "description": "MCP clients, servers and connectors \u2014 installing/enabling servers and invoking tools under credential governance.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Install an MCP server",
    "Enable an MCP server",
    "Invoke a tool",
    "Use a stored credential",
    "Connector operations"
   ]
  },
  {
   "id": "vpk_ai-infrastructure.multi-agent-organizations",
   "sector": "ai-infrastructure",
   "title": "Multi-Agent Organizations",
   "description": "Hierarchies of agents that spawn, delegate, message, share context/memory and transfer tasks and capabilities.",
   "tier": "governed",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Spawn a sub-agent",
    "Delegate a task",
    "Terminate an agent",
    "Agent-to-agent message",
    "Share context",
    "Share memory",
    "Transfer a task",
    "Transfer a capability"
   ]
  },
  {
   "id": "vpk_commerce-money.accounting",
   "sector": "commerce-money",
   "title": "Accounting",
   "description": "Ledger operations \u2014 journal entries, reconciliation, payables/receivables under close-calendar controls.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Post a journal entry",
    "Run reconciliation",
    "Approve an invoice",
    "Generate a report"
   ]
  },
  {
   "id": "vpk_commerce-money.banking",
   "sector": "commerce-money",
   "title": "Banking",
   "description": "Retail and business banking \u2014 balance reads, transfers and payments to declared beneficiaries under dual control.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Read balances",
    "Initiate a transfer",
    "Submit a payment",
    "Read statements"
   ]
  },
  {
   "id": "vpk_commerce-money.ecommerce",
   "sector": "commerce-money",
   "title": "E-commerce",
   "description": "Storefront agents managing catalog, orders, payments and refunds under store-scoped limits.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Charge an order",
    "Refund an order",
    "Update a product listing",
    "Fulfill an order",
    "Adjust inventory"
   ]
  },
  {
   "id": "vpk_commerce-money.fintech",
   "sector": "commerce-money",
   "title": "Fintech",
   "description": "API-first payment and wallet platforms \u2014 programmatic charges, payouts and wallet transfers within intent budgets.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Create a payment",
    "Create a payout",
    "Transfer between wallets",
    "Create a subscription"
   ]
  },
  {
   "id": "vpk_commerce-money.insurance",
   "sector": "commerce-money",
   "title": "Insurance",
   "description": "Policy administration and claims \u2014 quotes, endorsements, claims adjudication and payouts under coverage limits.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Issue/endorse a policy",
    "File a claim",
    "Adjudicate a claim",
    "Issue a claim payout"
   ]
  },
  {
   "id": "vpk_commerce-money.marketplaces",
   "sector": "commerce-money",
   "title": "Marketplaces",
   "description": "Multi-party listing, order and payout operations between buyers and sellers under marketplace limits.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Publish a listing",
    "Settle an order",
    "Release a payout",
    "Handle a dispute/chargeback"
   ]
  },
  {
   "id": "vpk_commerce-money.payroll",
   "sector": "commerce-money",
   "title": "Payroll",
   "description": "Payroll runs, employee payments and tax filings for declared employees under dual control.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Run payroll",
    "Adjust a pay item",
    "File a tax form",
    "Sync employee roster"
   ]
  },
  {
   "id": "vpk_commerce-money.procurement",
   "sector": "commerce-money",
   "title": "Procurement",
   "description": "Source-to-pay \u2014 requisitions, purchase orders, vendor onboarding and payment against matched documents.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Create a purchase order",
    "Approve a purchase order",
    "Onboard a vendor",
    "Match invoice to PO",
    "Release vendor payment"
   ]
  },
  {
   "id": "vpk_commerce-money.retail",
   "sector": "commerce-money",
   "title": "Retail",
   "description": "Point-of-sale and store operations \u2014 pricing, catalog, promotions and refunds under store-scoped limits.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Record a sale",
    "Issue a refund",
    "Update pricing",
    "Adjust inventory"
   ]
  },
  {
   "id": "vpk_commerce-money.treasury",
   "sector": "commerce-money",
   "title": "Treasury",
   "description": "Corporate treasury \u2014 liquidity moves, sweeps and hedging instructions between declared corporate accounts.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Execute a liquidity move",
    "Read positions",
    "Configure a sweep rule",
    "Generate a forecast"
   ]
  },
  {
   "id": "vpk_communication.email",
   "sector": "communication",
   "title": "Email",
   "description": "Email agents that read, triage, label, draft and send under capability-bound mailbox scope. L3: the Gmail integration carries real external-system proof via adapter-gmail and adapter-clawlink.",
   "tier": "production-integrated",
   "maturity": "L3",
   "liveProof": "live-proven",
   "actions": [
    "Send an email",
    "Read email",
    "Label/triage email",
    "Draft an email",
    "Create a calendar event from mail"
   ]
  },
  {
   "id": "vpk_communication.messaging",
   "sector": "communication",
   "title": "Messaging",
   "description": "Team and consumer messaging \u2014 channel reads, posts, replies and moderation on declared channels.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Send a chat message",
    "Read channel history",
    "React/moderate a message",
    "Manage a channel"
   ]
  },
  {
   "id": "vpk_communication.social-media",
   "sector": "communication",
   "title": "Social Media",
   "description": "Publishing and engagement on declared social accounts \u2014 draft, schedule, publish, reply under approval.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Publish a post",
    "Draft a post",
    "Reply to a mention",
    "Schedule a post"
   ]
  },
  {
   "id": "vpk_communication.telecom",
   "sector": "communication",
   "title": "Telecom",
   "description": "Voice and SMS \u2014 calls, texts and voicemail on declared phone numbers with recording evidence where lawful.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Send an SMS",
    "Place a call",
    "Transcribe voicemail",
    "Provision a number"
   ]
  },
  {
   "id": "vpk_consumer-family.elder-care",
   "sector": "consumer-family",
   "title": "Elder Care",
   "description": "Care monitoring and check-ins \u2014 scheduled check-ins, alert escalation and home-safety signals for an elder under care.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Perform a check-in",
    "Escalate an alert",
    "Read a safety sensor",
    "Notify a caregiver"
   ]
  },
  {
   "id": "vpk_consumer-family.family-ai",
   "sector": "consumer-family",
   "title": "Family AI",
   "description": "Household coordination \u2014 shared calendars, lists and devices across declared member scopes.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Create a family event",
    "Manage shared lists",
    "Message family members",
    "Control a household device"
   ]
  },
  {
   "id": "vpk_consumer-family.personal-assistants",
   "sector": "consumer-family",
   "title": "Personal Assistants",
   "description": "Individual assistant agents \u2014 email, calendar, tasks and purchases inside daily caps.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Send an email",
    "Create an event",
    "Manage tasks",
    "Make a purchase"
   ]
  },
  {
   "id": "vpk_enterprise-systems.crm-sales",
   "sector": "enterprise-systems",
   "title": "CRM & Sales",
   "description": "Pipeline operations \u2014 leads, opportunities, activities and quotes inside the declared book of business.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Update a CRM record",
    "Create a CRM record",
    "Log an activity",
    "Generate a quote",
    "Send outreach"
   ]
  },
  {
   "id": "vpk_enterprise-systems.customer-support",
   "sector": "enterprise-systems",
   "title": "Customer Support",
   "description": "Ticket triage, replies and resolution within declared queues and macro scope.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Reply to a ticket",
    "Triage/prioritize a ticket",
    "Resolve a ticket",
    "Suggest a knowledge article"
   ]
  },
  {
   "id": "vpk_enterprise-systems.enterprise-saas",
   "sector": "enterprise-systems",
   "title": "Enterprise SaaS",
   "description": "Tenant administration across business SaaS \u2014 users, seats, settings and integrations.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Provision a user",
    "Deprovision a user",
    "Update tenant settings",
    "Configure an integration"
   ]
  },
  {
   "id": "vpk_enterprise-systems.hr-workforce",
   "sector": "enterprise-systems",
   "title": "HR & Workforce",
   "description": "Employee lifecycle \u2014 onboarding, offboarding, records and scheduling inside a declared population.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Onboard an employee",
    "Offboard an employee",
    "Update an employee record",
    "Manage schedules"
   ]
  },
  {
   "id": "vpk_enterprise-systems.marketing",
   "sector": "enterprise-systems",
   "title": "Marketing",
   "description": "Campaign and audience operations \u2014 segments, sends and journeys on declared, consented audiences.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Launch a campaign",
    "Update an audience segment",
    "Send campaign email",
    "Read campaign metrics"
   ]
  },
  {
   "id": "vpk_movement-property.fleet",
   "sector": "movement-property",
   "title": "Fleet",
   "description": "Vehicle fleet operations \u2014 dispatch, telematics, maintenance and driver management.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Dispatch a vehicle/driver",
    "Read telematics",
    "Schedule maintenance",
    "Enforce a geofence"
   ]
  },
  {
   "id": "vpk_movement-property.hospitality",
   "sector": "movement-property",
   "title": "Hospitality",
   "description": "Guest operations \u2014 reservations, check-in/out, room changes and service requests.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Manage a reservation",
    "Handle a guest request",
    "Issue a room key",
    "Adjust a folio"
   ]
  },
  {
   "id": "vpk_movement-property.logistics",
   "sector": "movement-property",
   "title": "Logistics",
   "description": "Shipment lifecycle \u2014 labels, tracking, exceptions and carrier coordination.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Create a shipment",
    "Track a shipment",
    "Handle a delivery exception",
    "Shop carrier rates"
   ]
  },
  {
   "id": "vpk_movement-property.property-management",
   "sector": "movement-property",
   "title": "Property Management",
   "description": "Tenant and maintenance operations on declared properties \u2014 requests, vendors and access grants.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Handle a maintenance request",
    "Dispatch a vendor",
    "Grant property access",
    "Manage a lease"
   ]
  },
  {
   "id": "vpk_movement-property.real-estate",
   "sector": "movement-property",
   "title": "Real Estate",
   "description": "Listings, showings and transaction coordination on declared properties.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Manage a listing",
    "Schedule a showing",
    "Submit an offer",
    "Coordinate document signing"
   ]
  },
  {
   "id": "vpk_movement-property.supply-chain",
   "sector": "movement-property",
   "title": "Supply Chain",
   "description": "Multi-party order, stock and shipment coordination across suppliers and carriers.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Coordinate an order",
    "Rebalance stock",
    "Resolve a supply exception",
    "Update a demand forecast"
   ]
  },
  {
   "id": "vpk_movement-property.travel",
   "sector": "movement-property",
   "title": "Travel",
   "description": "Trip booking \u2014 flights, hotels, cars and itinerary changes within travel policy and budget.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Search travel options",
    "Create a booking",
    "Change/cancel a booking",
    "Sync the itinerary"
   ]
  },
  {
   "id": "vpk_physical-world.autonomous-vehicles",
   "sector": "physical-world",
   "title": "Autonomous Vehicles",
   "description": "Vehicle dispatch \u2014 route assignment and mission control on approved corridors under sealed runtime.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Dispatch a vehicle",
    "Assign a route",
    "Recall a vehicle",
    "Read vehicle telemetry"
   ]
  },
  {
   "id": "vpk_physical-world.construction",
   "sector": "physical-world",
   "title": "Construction",
   "description": "Site coordination \u2014 equipment telemetry, inspections and crew tasks on declared sites.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Record an inspection",
    "Command equipment",
    "Assign a site task",
    "Raise a safety alert"
   ]
  },
  {
   "id": "vpk_physical-world.drones",
   "sector": "physical-world",
   "title": "Drones",
   "description": "Drone missions \u2014 geofenced flight plans, capture tasks and return-to-home under airspace rules.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Plan a mission",
    "Launch a mission",
    "Abort/return home",
    "Collect imagery"
   ]
  },
  {
   "id": "vpk_physical-world.energy-utilities",
   "sector": "physical-world",
   "title": "Energy & Utilities",
   "description": "Grid and plant operations \u2014 metering, generation control and outage response under reliability rules.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Read meters",
    "Dispatch generation",
    "Respond to an outage",
    "Adjust load"
   ]
  },
  {
   "id": "vpk_physical-world.field-service",
   "sector": "physical-world",
   "title": "Field Service",
   "description": "Work-order dispatch and documentation \u2014 assign, route and close declared field jobs.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Dispatch a work order",
    "Update a work order",
    "Optimize routes",
    "File a service report"
   ]
  },
  {
   "id": "vpk_physical-world.industrial-ops",
   "sector": "physical-world",
   "title": "Industrial Operations",
   "description": "Plant telemetry and process control \u2014 monitor, adjust setpoints and raise alarms.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Read telemetry",
    "Adjust a setpoint",
    "Raise an alarm",
    "Schedule maintenance"
   ]
  },
  {
   "id": "vpk_physical-world.manufacturing",
   "sector": "physical-world",
   "title": "Manufacturing",
   "description": "Production-line operations \u2014 machine control, quality checks and scheduling inside a safety envelope.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Start a machine",
    "Stop a machine",
    "Run a quality check",
    "Adjust the line schedule"
   ]
  },
  {
   "id": "vpk_physical-world.robotics",
   "sector": "physical-world",
   "title": "Robotics",
   "description": "Robot tasking \u2014 bounded motion, pickup/place and navigation inside declared zones.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Move a robot",
    "Assign a robot task",
    "Stop a robot",
    "Read robot telemetry"
   ]
  },
  {
   "id": "vpk_physical-world.smart-home",
   "sector": "physical-world",
   "title": "Smart Home",
   "description": "Home device control \u2014 locks, lights, climate and cameras within resident-approved scopes.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Control a device",
    "Operate a lock",
    "Activate a scene",
    "View a camera"
   ]
  },
  {
   "id": "vpk_physical-world.warehousing",
   "sector": "physical-world",
   "title": "Warehousing",
   "description": "Warehouse robotics and inventory \u2014 tote routing, pick tasks and cycle counts inside zones.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Assign a pick task",
    "Route a warehouse robot",
    "Run a cycle count",
    "Restrict a zone"
   ]
  },
  {
   "id": "vpk_regulated-data.compliance",
   "sector": "regulated-data",
   "title": "Compliance",
   "description": "Control monitoring and evidence \u2014 audit-log review, evidence collection and policy attestation across frameworks.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Collect control evidence",
    "Record an attestation",
    "File a policy exception",
    "Generate a compliance report"
   ]
  },
  {
   "id": "vpk_regulated-data.education",
   "sector": "regulated-data",
   "title": "Education",
   "description": "Student records and enrollment \u2014 registrar operations under FERPA scope.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Release a student record",
    "Process enrollment",
    "Issue a transcript",
    "Record consent"
   ]
  },
  {
   "id": "vpk_regulated-data.government",
   "sector": "regulated-data",
   "title": "Government",
   "description": "Public-sector service delivery \u2014 permits, records and citizen requests under full audit lineage.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Process a service request",
    "Issue a permit",
    "Release a public record",
    "Receive a filing"
   ]
  },
  {
   "id": "vpk_regulated-data.healthcare",
   "sector": "regulated-data",
   "title": "Healthcare",
   "description": "Provider and payer operations \u2014 records access, scheduling, claims and coordination under HIPAA-scope consent.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "View a patient record",
    "Disclose a record",
    "Book an appointment",
    "Submit a claim",
    "Use protected data",
    "Disclose protected data"
   ]
  },
  {
   "id": "vpk_regulated-data.legal",
   "sector": "regulated-data",
   "title": "Legal",
   "description": "Matter and contract work \u2014 drafting, review, filing and disclosure under privilege scope.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Draft a document",
    "Review/annotate a document",
    "Execute a contract",
    "Submit a filing"
   ]
  },
  {
   "id": "vpk_regulated-data.pharma-life-sciences",
   "sector": "regulated-data",
   "title": "Pharma & Life Sciences",
   "description": "Clinical and lab operations \u2014 trial documentation, lab results and consent under GCP/GxP scope.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "File a study document",
    "Report a lab result",
    "Verify consent",
    "Log a deviation"
   ]
  },
  {
   "id": "vpk_regulated-data.privacy-dlp",
   "sector": "regulated-data",
   "title": "Privacy & DLP",
   "description": "Data-subject rights, classification and egress control over the protected catalog.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Use protected data",
    "View protected data",
    "Disclose protected data",
    "Export protected data",
    "Fulfill a data subject request"
   ]
  },
  {
   "id": "vpk_security-it.cybersecurity",
   "sector": "security-it",
   "title": "Cybersecurity",
   "description": "Vulnerability and posture management \u2014 scan, triage and remediate findings on declared assets.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Run a scan",
    "Triage a finding",
    "Apply a patch",
    "Close an exposure"
   ]
  },
  {
   "id": "vpk_security-it.iam-identity",
   "sector": "security-it",
   "title": "IAM & Identity",
   "description": "Identity lifecycle \u2014 users, groups, roles, credentials and access reviews under duty separation.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Provision an identity",
    "Deprovision an identity",
    "Grant a role/group",
    "Revoke access",
    "Run an access review",
    "Change MFA state"
   ]
  },
  {
   "id": "vpk_security-it.it-administration",
   "sector": "security-it",
   "title": "IT Administration",
   "description": "Fleet and endpoint operations \u2014 device management, software deployment and service operations.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Send a device command",
    "Deploy software",
    "Restart a service",
    "Sync asset inventory"
   ]
  },
  {
   "id": "vpk_security-it.soc-secops",
   "sector": "security-it",
   "title": "SOC & SecOps",
   "description": "Alert triage, enrichment and containment \u2014 isolate hosts, block indicators, escalate to humans.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Triage an alert",
    "Isolate a host",
    "Block an indicator",
    "Escalate a case",
    "Run a detection query"
   ]
  },
  {
   "id": "vpk_software-delivery.api-automation",
   "sector": "software-delivery",
   "title": "API Automation",
   "description": "Endpoint automation \u2014 declared API calls, webhooks and scheduled jobs through enforced egress.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Bounded API request",
    "Fire a webhook",
    "Schedule a job",
    "Use a stored credential"
   ]
  },
  {
   "id": "vpk_software-delivery.cicd",
   "sector": "software-delivery",
   "title": "CI/CD",
   "description": "Build and release pipelines \u2014 triggers, promotions and rollbacks on declared services.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Trigger a pipeline",
    "Promote a deployment",
    "Roll back a deployment",
    "Read build logs"
   ]
  },
  {
   "id": "vpk_software-delivery.cloud-devops",
   "sector": "software-delivery",
   "title": "Cloud & DevOps",
   "description": "Cloud resource operations \u2014 instances, containers, DNS and scaling on declared accounts.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Manage compute instances",
    "Adjust scaling",
    "Update DNS",
    "Delete a resource"
   ]
  },
  {
   "id": "vpk_software-delivery.data-platforms",
   "sector": "software-delivery",
   "title": "Data Platforms",
   "description": "Pipeline and warehouse operations \u2014 jobs, datasets and dashboards on declared data stores.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Run a data job",
    "Publish a dataset",
    "Execute a query",
    "Update a dashboard"
   ]
  },
  {
   "id": "vpk_software-delivery.database-administration",
   "sector": "software-delivery",
   "title": "Database Administration",
   "description": "Migrations and maintenance on declared databases \u2014 schema changes, backups and access grants.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Run a migration",
    "Create a backup",
    "Grant DB access",
    "Drop a table"
   ]
  },
  {
   "id": "vpk_software-delivery.developer-tools",
   "sector": "software-delivery",
   "title": "Developer Tools",
   "description": "Coding agents in repos and issue trackers \u2014 edits, branches, PRs and reviews within declared repos.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Write files",
    "Run local commands",
    "Open a pull request",
    "Review a pull request",
    "Update an issue"
   ]
  },
  {
   "id": "vpk_software-delivery.iac",
   "sector": "software-delivery",
   "title": "Infrastructure as Code",
   "description": "Plan/apply infrastructure changes \u2014 plan review, apply and state operations under dual control.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Generate a plan",
    "Apply a plan",
    "Read state",
    "Destroy a resource"
   ]
  },
  {
   "id": "vpk_software-delivery.kubernetes",
   "sector": "software-delivery",
   "title": "Kubernetes",
   "description": "Cluster workload operations \u2014 apply, scale, restart and roll back workloads in declared namespaces.",
   "tier": "integration-ready",
   "maturity": "L1",
   "liveProof": "none",
   "actions": [
    "Apply a workload manifest",
    "Scale a workload",
    "Restart a workload",
    "Delete a workload"
   ]
  }
 ]
} as const;
